import { MoneyBox } from '@apply/components';

interface TransactionFeeProps {
    fee: number;
}

export const TransactionFee: React.FC<TransactionFeeProps> = ({ fee }) => {
    const label = 'Transaction Fee of 3% ';
    return (
        <>
            <MoneyBox
                id='transactionFee'
                allowNegative={false}
                value={fee}
                onChange={() => {}}
                required={true}
                label={label}
                displayChange={true}
                readOnly={true}
            />
        </>
    );
};
